<script>
import dialog2Mixin from "../mixins/dialog2";
import { merchantComputed } from '@store/helpers'

export default {

  mixins: [dialog2Mixin],
  data() {
    return {
      storeTitle: '',
      phoneNumber: '',
    }
  },
  computed: {
    ...merchantComputed,

  },
  mounted() {
 
  },
  methods: {
    formatLineId(lineId = '') {
      return lineId.replace('@', '')
    },
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogLine } isStyleBase text-center`"
    width="768px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div ref="addImage"></div>
    <div class="dialogLine__title">
      <span>升級會員等級</span>
    </div>
    <div class="dialogLine__description">
      如您需要升級會員等級， 
      <br>請撥打下方電話直接聯繫，
      <br>我們將竭誠為您服務。
      <br><br>
      <i class="fas fa-phone text-primary"></i>
      <a 
        :href="`tel:${currentMerchant.phoneNumber}`"
        class="text-gray-2"
      >
        {{currentMerchant.phoneNumber}}
      </a>
      <div v-if="currentMerchant.lineId" class="text-center my-4">
        <span>
          <i class="fontello fontello-line-solid mr-2 fa-lg text-primary"></i>
          <span>@{{ formatLineId(currentMerchant.lineId) }}</span>
        </span>
      </div>
    </div>
    <BaseButton
      class="isStylePrimary isFull"
      :class="{ 'isRadius': $globalIsJtails }"
      @click="dialog2MixinVisible = false"
    >
      我瞭解了
    </BaseButton>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogLine {
  :global {
    .dialogLine {
      &__title {
        margin-bottom: 2.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
      }

      &__qrcodeBox {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 195px;
        height: 195px;
        margin: 0 auto 2rem;
        background: darken(#FFF, 1%);
      }

      &__qrcode {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        user-select: none;
      }

      &__description {
        margin-bottom: 2.5rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
      }
    }
  }
}
</style>
